export default __webpack_public_path__ + "static/iconLot-green-893ea7ea398fa73565b30e2a3a590dc3.svg";